import React, { useContext, useState, useEffect, useCallback } from 'react'
import { TenantsContext } from '../../../context/tenants.context'
import { LocalVendedorDTO } from '../../../dto/LocalDTO'
import { getLocal } from '../../AbmLocalPage/services/locales.service'

interface LocalContextProps {
  loading: boolean
  local: LocalVendedorDTO
  codLocal: string
  setCodLocal: (cod: string) => void
  fetchData: () => Promise<void>
}

// create context
export const LocalContext = React.createContext<LocalContextProps>({
  loading: false,
  local: null,
  codLocal: null,
  setCodLocal: () => {},
  fetchData: async () => {}
})

// create provider
export const LocalProvider = ({ children }: any) => {
  const { tenant } = useContext(TenantsContext)
  const [loading, setLoading] = useState<boolean>(false)
  const [codLocal, setCodLocal] = useState<string>(null)
  const [local, setLocal] = useState<LocalVendedorDTO>(null)

  const fetchData = useCallback(async () => {
    try {
      setLoading(true)
      await getLocal(codLocal, tenant).then((res) => setLocal(res.data.data))
    } catch (e) {
      console.log(e)
    } finally {
      setLoading(false)
    }
  }, [codLocal, tenant])

  useEffect(() => {
    if (!codLocal) return setLocal(null)
    fetchData()
  }, [codLocal])

  return (
    <LocalContext.Provider
      value={{
        loading,
        local,
        codLocal,
        setCodLocal,
        fetchData
      }}
    >
      {children}
    </LocalContext.Provider>
  )
}
